import { Codec } from '../../serialization/types'
import { CreateQueryCodec, UrlQuery, UrlQueryCodec } from '../types'

export type SimpleQueryMapping = Record<string, [string, Codec<any>]>

export class AppUrlQueryCodec<T> implements UrlQueryCodec<T> {
    constructor(private mapping: SimpleQueryMapping) {}

    decode = (q: UrlQuery): T => {
        // @ts-ignore
        const t: T = {}

        this.visitAll((key, paramName, codec) => {
            const val = q[paramName]
            // @ts-ignore
            if (val !== undefined) {
                try {
                    // @ts-ignore
                    t[key] = codec.decode(val)
                } catch (e: any) {
                    console.error(
                        'Error while parsing param: "' +
                            paramName +
                            '". ' +
                            e.toString(),
                        'Ignoring.'
                    )
                }
            }
        })

        return t
    }

    encode = (t: T): UrlQuery => {
        const q = {}
        this.visitAll((key, paramName, codec) => {
            // @ts-ignore
            const val = t[key]

            // Set values as undefined so they are deleted from the query when merged
            // @ts-ignore
            q[paramName] = val == null ? undefined : codec.encode(val)
        })

        return q
    }

    private visitAll = (
        visit: (key: string, paramName: string, codec: Codec<any>) => void
    ): void => {
        Object.entries(this.mapping).forEach(([key, [paramName, codec]]) =>
            visit(key, paramName, codec)
        )
    }
}

const createMapping = (
    fields: [string, Codec<any>][],
    prefix?: string
): SimpleQueryMapping => {
    const res: SimpleQueryMapping = {}

    fields.forEach(([key, codec]) => {
        const queryKey = prefix ? `${prefix}.${key}` : key
        res[key] = [queryKey, codec]
    })

    return res
}

export const createQueryCodec: CreateQueryCodec = (
    fields: [string, Codec<any>][],
    prefix?: string
) => {
    const mapping = createMapping(fields, prefix)
    return new AppUrlQueryCodec(mapping)
}
